import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import LeftSideNavigation from '../navigationSection/LeftSideNavigation';
import RightSideNavigation from '../navigationSection/RightSideNavigation';
import { TopNavigationBarMobile } from '../navigationSection/TopNavigationBarMobile';
import AddItemMain from './AddItemMain';
import Media from 'react-media';
import { BottomNavigationMobile } from '../navigationSection/BottomNavigationMobile';

class AddItemAvailability extends Component {
  render() {
    const { state } = this.props.location;
    return (
      <React.Fragment>
        <div className="container-fluid add-item-availability">
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>
            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/itemavailablitydashboard"
                displayText="Back"
                noEnAdminPic={true}
              />
              <div className="p-2 mt-2">
                <AddItemMain
                  dash={true}
                  pathname="/itemavailablitydashboard"
                  menuData={state}
                />
              </div>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
            <div className="bottom-panel"></div>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default AddItemAvailability;
